<template>
  <div role="alert" class="d-flex text-center justify-content-center align-items-center position-absolute position-top-0 w-100 h-px-80 z-index-10 px-4 bg-blue" v-if="$root.isAppReconnecting && !$router.disableReconnectingMessageRoutes.includes($route.name)">
    <div class="d-flex align-items-center h-100">
      <font-awesome-icon :icon="['fal', 'spinner']" spin role="presentation" class="mr-3 font-size-rem-16" />
    </div>
    <div class="d-flex flex-wrap justify-content-center">
      <span class="d-flex align-self-center font-size-rem-12 mr-1">{{ $t('Reconnecting.Connection lost') }}</span>
      <span class=" font-size-rem-12">{{ $t('Reconnecting.Trying to reconnect') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reconnecting',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
</style>
